export default __webpack_public_path__ + "static/media/logo.9859c5e1.png";